import { render } from "./SharedFileCard.vue?vue&type=template&id=72b08e6f&scoped=true"
import script from "./SharedFileCard.vue?vue&type=script&lang=js"
export * from "./SharedFileCard.vue?vue&type=script&lang=js"

import "./SharedFileCard.vue?vue&type=style&index=0&id=72b08e6f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72b08e6f"]])

export default __exports__